import { useEffect, useState } from "react";
import SemanticDatepicker from "react-semantic-ui-datepickers";
import { Button, Form, Modal } from "semantic-ui-react";
import { isNumber } from "lodash";
import moment from "moment";
import { trancateTime } from "../utils";

interface Props {
  title?: string;
  open: boolean;
  currentTo?: Date | string;
  maxPermitDurationDays?: number | null;
  onClose: () => void;
  onSubmit: (to: Date, comments: string) => void;
  submitInProgress: boolean;
}

const ExtendPermitModal = ({
  title,
  open,
  currentTo,
  maxPermitDurationDays,
  onClose,
  onSubmit,
  submitInProgress,
}: Props) => {
  const [comments, setComments] = useState<string>("");
  const [to, setTo] = useState<Date | null>();
  const [toError, setToError] = useState<string>("");

  useEffect(() => {
    setComments("");
    setTo(null);
    setToError("");
  }, [open]);

  const handleChange = (e: any, { name, value }: any) => {
    setComments(value);
  };

  const onToDateChange = (e: any, data: any) => {
    setTo(data.value);
    setToError("");
  };

  const handleSubmit = () => {
    if (!to) {
      setToError("Please enter date");
      return;
    }

    onSubmit(trancateTime(to), comments);
  };

  const handelClose = () => {
    setComments("");
    onClose();
  };

  const currentToStartOfDay = currentTo ? moment(currentTo).startOf("day") : undefined;

  const minDate = currentToStartOfDay?.clone().add(1, "day").toDate();

  const maxDate =
    currentToStartOfDay && isNumber(maxPermitDurationDays)
      ? currentToStartOfDay.clone().add(maxPermitDurationDays, "days").toDate()
      : undefined;

  return (
    <Modal open={open} size="mini">
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Form>
            <Form.Group widths="equal">
              <SemanticDatepicker
                required
                label="To"
                value={to}
                error={toError}
                locale="en-US"
                onChange={onToDateChange}
                type="basic"
                minDate={minDate}
                maxDate={maxDate}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.TextArea value={comments} label="Comments" name="comments" onChange={handleChange} />
            </Form.Group>
          </Form>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handelClose}>Cancel</Button>
        <Button onClick={handleSubmit} positive loading={submitInProgress} disabled={submitInProgress}>
          Ok
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ExtendPermitModal;
